import { useGlobalContext } from "../Context"
import { useEffect, useState } from "react"
import { Input } from 'antd';
const { Search } = Input;

const SearchBox = () => {

    const { searchKeyword, setSearchKeyword } = useGlobalContext();
    const [text, setText] = useState(searchKeyword);

    const handleSearch = (searchTerm) => {
        console.log(`onSearch with keyword - ${searchTerm}`);
        setText(searchTerm);
        if (searchTerm) {
            console.log(`Submit search with keyword - ${text}`);
            setSearchKeyword(searchTerm);
        }
    }

    const onSearch = (value, _e, info) => {
        var searchTerm = value
        handleSearch(searchTerm);
    }

    const handleSubmit = (e) => {
        var searchTerm = e.target.value
        handleSearch(searchTerm);
    }
    

    useEffect(() => {
        var saveKeyword = localStorage.getItem('searchKeyword');
        if (saveKeyword) {
            setText(saveKeyword);
            setSearchKeyword(saveKeyword);
        }
    }, [setSearchKeyword]);

    return (
        <Search
            placeholder="Enter the restaurant or street name"
            allowClear
            enterButton="Search"
            size="large"
            style={{
                width: "100%",
            }}
            onSearch={onSearch}
            onPressEnter={handleSubmit}
        />
    )
}

export default SearchBox